import type { Release } from '../../../types';

const brakeRobotSide: Release = {
  name: 'brake (robotside)',
  short_description: 'Synthetic Mechanical Rhythms & Modular Experimentation',
  description:
    "Brake (robotside) represents the mechanical and rhythmically charged counterpart in joev's double EP release. Built on crisp modular synth patches, pulsing sub-bass architecture, and driving percussive grooves, the EP explores the tension between mechanical precision and organic electronic warmth across three dynamic tracks ('opening', 'leave or stay', 'dark horse').",
  tracklist: [
    {
      trackname: 'opening',
      duration: '3:10 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/opening',
      },
    },
    {
      trackname: 'leave or stay',
      duration: '4:58 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/leave-or-stay',
      },
    },
    {
      trackname: 'dark horse',
      duration: '3:09 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/dark-horse',
      },
    },
  ],
  date: '12-2019',
  bgColor: '#A8D3AF',
  cover: 'joevnoise_brake-robotside.png',
  detail_link: 'brake-robotside',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/brake-robotside',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise',
    },
  ],
};

export default brakeRobotSide;
